module.exports = __webpack_public_path__ + "static/gallery-img-33-503e581b94add953a5d95d3043d73b92.jpg";